'use strict';

try {
  window.devicePixelRatio = (function () {
    var ratio = 1;

    if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
      ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
    } else if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio;
    }

    return ratio;
  })();
} catch (err) { }


/** WEBPACK FOOTER **
 ** ./utils/polyfills/window.devicePixelRatio.js
 **/